import clsx from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    onDropApplication,
    onSearchApplicationClick,
    onSearchApplicationRolClick
} from '../../store/user/actions';

import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import { FieldSet } from '@sigeco/tools';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    chip: {
        margin: '0.375rem 0.375rem 0 0'
    },
    content: {
        padding: '0.5rem 0.75rem 0.75rem'
    },
    icon: {
        fontSize: '1rem'
    },
    editIcon: {
        fontSize: '0.75rem'
    },
    root: {
        flex: '0 0 auto',
        marginBottom: '0.75rem',
        '@media (min-width: 1401px)': {
            marginBottom: '1rem',
        }
    }
}));

const UserApplication = () => {
    const classes = useStyles();
    const aplicaciones = useSelector(state => state.user.entity.aplicaciones);
    const formState = useSelector(state => state.user.formState);
    const dispatch = useDispatch();
    const canEdit = formState === 'edit' || formState === 'new';

    const handleDelete = aplicacionClienteId => dispatch(onDropApplication(aplicacionClienteId));

    const handleEditRol = aplicacionClienteId => dispatch(onSearchApplicationRolClick(aplicacionClienteId));

    function getChipLabel(item) {
        return item.rol ? `${item.nombre} - ${item.rol}` : item.nombre;
    }

    return (
        <div className={classes.root}>
            <FieldSet  iconCls="fab fa-app-store" title="Aplicaciones Permitidas">
                <div className={classes.content}>
                    {canEdit && (<div>
                        <Fab aria-label="agregar" color="primary" onClick={() => dispatch(onSearchApplicationClick())} size="small">
                            <Icon className={clsx("fas fa-plus", classes.icon)} style={{ fontSize: '0.875rem'}}/>
                        </Fab>
                    </div>)}
                    {aplicaciones.map((item, index) => {
                        return (
                            <div key={index} style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <Chip
                                    className={classes.chip}
                                    color="default"
                                    deleteIcon={<Icon className="fas fa-times-circle" style={{ fontSize: '1rem'}} />}
                                    label={getChipLabel(item)}
                                    onDelete={canEdit ? () => handleDelete(item.aplicacionClienteId) : null}
                                    variant="outlined" 
                                />
                                {canEdit && (
                                    <IconButton
                                        aria-label="editar rol"
                                        onClick={() => handleEditRol(item.aplicacionClienteId)}
                                        size="small"
                                        style={{ padding: 4, marginTop: '0.375rem' }}
                                    >
                                        <Icon className={clsx("fas fa-pencil-alt", classes.editIcon)} />
                                    </IconButton>
                                )}
                            </div>
                        )
                    })}
                </div>
            </FieldSet>
        </div>
    );

};

export default UserApplication;